import styled from 'styled-components'

export * from 'styled-components'
export { styled }
